(function documentContainersShortcutsDefinition() {
    'use strict';
    angular.module('Entities')
        .service('documentContainersShortcutsService', [
            'restUrlBuilder', function documentContainersShortcutsService(restUrlBuilder) {

                this.findShort = function get(name, id, createdBy, createdDateFrom, createdDateTo, page, itemsPerPage, orderBy, asc) {
                    var params = { Name: name, Id: id, CreatedBy: createdBy, CreatedDateFrom: createdDateFrom, CreatedDateTo: createdDateTo, ItemPerPage: itemsPerPage, Page: page, OrderBy: orderBy, OrderAscendent: asc};

                    return restUrlBuilder.all('DocumentContainersShortcuts')
                        .get({ params: params });
                };
            }
        ]);
})();